import React from 'react';
import FieldItem from './FieldItem';
import './fields.scss';

export enum FieldItemType {
  field = 'field',
  snapshot = 'snapshot',
}

export interface FieldItemProps {
  label: string;
  value: string | number;
  values: any[];
  type: FieldItemType;
  key: string;
  fieldKey: string;
  unit?: string;
  icon?: string;
  handleClickItem?: AnyFunc;
  slot?: any;
  children?: any;
  showPreviewName?: boolean; //是否显示预览文件名称（上方预览文件或文件，下方显示预览文件名称）false将不展示下方的名称
}
export interface FieldsGroupProps {
  title?: string;
  fields?: FieldItemProps[];
  handleClickItem?: AnyFunc;
  slot?: any;
  children?: any;
}
const FieldsGroup = (props: FieldsGroupProps) => {
  const { title, fields = [], handleClickItem, slot, children } = props;
  return (
    <div className='fields-group-wrapper'>
      {title && <div className='title'>{title}</div>}
      {fields.filter(Boolean).map((item, index) => (
        <FieldItem
          {...item}
          fieldKey={item.key}
          key={`${item.value}_${index}`}
          handleClickItem={handleClickItem}
          slot={slot && slot[item.key] ? slot[item.key] : null}
          children={children && children[item.key] ? children[item.key] : null}
        />
      ))}
    </div>
  );
};

export default React.memo(FieldsGroup);
